module.exports = __webpack_public_path__ + "img/profile.1511ed2d.jpg";